"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContextMenuSearch = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const use_t_1 = require("use-t");
const context_1 = require("../context");
const useBehaviorSubject_1 = require("../../../../hooks/useBehaviorSubject");
const Input_1 = require("../../../../2-inline-block/Input");
const nano_theme_1 = require("nano-theme");
const BasicButtonClose_1 = require("../../../../2-inline-block/BasicButton/BasicButtonClose");
const EmptyState_1 = require("../../../EmptyState");
const ContextItemNested_1 = require("../../ContextItemNested");
const GroupTitle_1 = require("./GroupTitle");
const ContextSep_1 = require("../../ContextSep");
const OpenPanelState_1 = require("../OpenPanelState");
const Scrollbox_1 = require("../../../Scrollbox");
const popup_1 = require("../../../../utils/popup");
const MoveToViewport_1 = require("../../../../utils/popup/MoveToViewport");
var HEIGHT;
(function (HEIGHT) {
    HEIGHT[HEIGHT["SEARCH"] = 45] = "SEARCH";
    HEIGHT[HEIGHT["SEPARATOR"] = 7] = "SEPARATOR";
})(HEIGHT || (HEIGHT = {}));
const ContextMenuSearch = ({ inset, searchPlaceholder, ContextMenuPane }) => {
    const [t] = (0, use_t_1.useT)();
    const state = (0, context_1.useContextMenu)();
    const search = (0, useBehaviorSubject_1.useBehaviorSubject)(state.search$);
    const matches = (0, useBehaviorSubject_1.useBehaviorSubject)(state.matches$);
    const anchor = (0, popup_1.useAnchorPoint)();
    const openPanel = React.useMemo(() => new OpenPanelState_1.OpenPanelState({ armed: true }), []);
    const selected = (0, useBehaviorSubject_1.useBehaviorSubject)(openPanel.selected$);
    let results = null;
    if (search) {
        if (!matches || !matches.length) {
            results = React.createElement(EmptyState_1.EmptyState, { emoji: ' ' });
        }
        else {
            let lastPathStr = '';
            const list = matches.map(({ item, path }, index) => {
                const pathStr = path.map((item) => item.id ?? item.name).join('/');
                const samePath = pathStr === lastPathStr;
                const isFirst = index === 0;
                const children = item.children;
                const hasPane = !!item.pane;
                const hasRaw = !!item.raw;
                const navigable = !!children || hasPane || hasRaw;
                const id = item.id ?? item.name;
                const compositeId = pathStr ? pathStr + '/' + id : id;
                lastPathStr = pathStr;
                const handleMouseMove = () => openPanel.onMouseMove(compositeId);
                const isOpen = selected === compositeId;
                const hasArgs = !!item.params?.length;
                return (React.createElement(React.Fragment, { key: compositeId },
                    !isFirst && !samePath && React.createElement(ContextSep_1.ContextSep, null),
                    !isFirst && !samePath && React.createElement(ContextSep_1.ContextSep, { line: true }),
                    !isFirst && !samePath && React.createElement(ContextSep_1.ContextSep, null),
                    !!path.length && !samePath && React.createElement(GroupTitle_1.GroupTitle, { path: path, off: 1 }),
                    React.createElement("div", { "data-menu-row": true, "data-menu-id": compositeId },
                        React.createElement(ContextItemNested_1.ContextItemNested, { open: isOpen, key: pathStr + (item.id || item.name), inset: inset, more: item.more, nested: navigable, icon: item.icon?.(), right: item.right?.(), danger: item.danger, mono: item.mono, onClick: hasArgs
                                ? () => {
                                    state.selectArgs(path, item);
                                }
                                : hasPane || hasRaw
                                    ? () => {
                                        state.select(path, item);
                                    }
                                    : item.onSelect
                                        ? (event) => state.execute(item, event)
                                        : children
                                            ? () => {
                                                state.select(path, item);
                                            }
                                            : void 0, renderPane: navigable
                                ? () => (React.createElement(MoveToViewport_1.MoveToViewport, null,
                                    React.createElement(ContextMenuPane, { ...state.props, depth: 1, path: path, menu: item, showSearch: false, onEsc: () => openPanel.deselect() })))
                                : void 0, onMouseEnter: handleMouseMove, onMouseMove: handleMouseMove, onMouseLeave: openPanel.onMouseLeave, role: "menuitem", tabIndex: -1, "aria-haspopup": navigable ? 'menu' : undefined, "aria-expanded": navigable ? isOpen : undefined }, item.display?.() ?? t(item.name)))));
            });
            const handleResultKeyDown = (e) => {
                if (e.key === 'ArrowRight') {
                    const row = e.target.closest?.('[data-menu-row]');
                    const menuId = row?.getAttribute('data-menu-id');
                    if (menuId) {
                        e.preventDefault();
                        e.stopPropagation();
                        openPanel.forceSelect(menuId);
                    }
                }
                else if (e.key === 'ArrowLeft') {
                    if (openPanel.deselect()) {
                        e.preventDefault();
                        e.stopPropagation();
                    }
                }
            };
            results = (
            // eslint-disable-next-line jsx-a11y/no-static-element-interactions
            React.createElement("div", { onKeyDown: handleResultKeyDown },
                React.createElement(Scrollbox_1.Scrollbox, { style: {
                        maxHeight: (anchor?.maxHeight() ?? window.innerHeight) - HEIGHT.SEARCH - HEIGHT.SEPARATOR - HEIGHT.SEPARATOR,
                    } }, list),
                !!list.length && React.createElement(ContextSep_1.ContextSep, { key: 'bottom-pad' })));
        }
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { "data-menu-row": true, style: { padding: '0 8px 8px' } },
            React.createElement(Input_1.Input, { focus: true, size: -2, placeholder: searchPlaceholder ?? t('Find') + nano_theme_1.SYMBOL.ELLIPSIS, right: search ? React.createElement(BasicButtonClose_1.BasicButtonClose, { onClick: () => state.search$.next('') }) : void 0, value: search, onChange: (value) => state.search$.next(value), onKeyDown: (e) => {
                    if (e.key === 'Backspace' && !state.search$.getValue()) {
                        e.preventDefault();
                        e.stopPropagation();
                        state.onclose?.();
                    }
                }, onEnter: (e) => {
                    if (!state.search$.getValue())
                        return;
                    const top = state.matches$.getValue()?.[0];
                    if (!top)
                        return;
                    e.preventDefault();
                    e.stopPropagation();
                    const { item, path } = top;
                    if (item.params?.length)
                        state.selectArgs(path, item);
                    else if (item.pane || item.raw || item.children)
                        state.select(path, item);
                    else if (item.onSelect)
                        state.execute(item, e);
                }, onEsc: (e) => {
                    if (state.search$.getValue()) {
                        e.preventDefault();
                        e.stopPropagation();
                        state.search$.next('');
                    }
                    // When search is empty, let the event bubble to the container's
                    // keyboard handler (breadcrumb back-navigation → close menu).
                } })),
        results));
};
exports.ContextMenuSearch = ContextMenuSearch;
